import { isAdministradorOuCentral } from '../security/AuthorizedFunction';

export const getEdicao = contexts => contexts.edicao;
export const getAno = contexts => contexts.ano;
export const getEdicaoCompleta = contexts => `${getEdicao(contexts)}ª Olimpíada de Professores da OBMEP Mirim ${getAno(contexts)}`;

export const getDataInicioDeInscricaoFormatada = contexts => contexts.dataInicioInscricao;
export const getDataFimDeInscricaoFormatada = contexts => contexts.dataFimInscricao;
export const getDataFimDeInscriocaoAdministradorFormatada = contexts => contexts.dataFimInscricaoAdministrador;
export const getPeriodoDeInscricaoFormatado = contexts => contexts.periodoInscricaoFormatado;
export const getPeriodoDeInscricaoAdministradorFormatado = contexts => contexts.periodoInscricaoAdministradorFormatado;
	
export const getDataInicioDePagamentoFormatado = contexts => contexts.dataInicioPagamento;
export const getDataFimDePagamentoFormatado = contexts => contexts.dataFimPagamento;
export const getDataFimDePagamentoAdministradorFormatado = contexts => contexts.dataFimPagamentoAdministrador;
export const getPeriodoDePagamentoFormatado = contexts => contexts.periodoPagamentoFormatado;
export const getPeriodoDePagamentoAdministradorFormatado = contexts => contexts.periodoPagamentoAdministradorFormatado;

export const getDataInicioDeConfirmacaoFormatado = contexts => contexts.dataInicioConfirmacao;
export const getDataFimDeConfirmacaoFormatado = contexts => contexts.dataFimConfirmacao;
export const getPeriodoDeConfirmacaoFormatado = contexts => contexts.periodoConfirmacaoFormatado;

export const getDataInicioDeTransitoFormatado = contexts => contexts.dataInicioTransito;
export const getDataFimDeTransitoFormatado = contexts => contexts.dataFimTransito;
export const getPeriodoDeTransitoFormatado = contexts => contexts.periodoTransitoFormatado;
	
export const getDataDaProvaFormatado = contexts => contexts.dataProva;
export const getDataDaDivulgacaoDeNotasFormatado = contexts => contexts.dataDivulgacaoNotas;
	
export const getDataInicioDeRevisaoFormatado = contexts => contexts.dataInicioRevisao;
export const getDataFimDeRevisaoFormatado = contexts => contexts.dataFimRevisao;
export const getPeriodoDeRevisaoFormatado = contexts => contexts.periodoRevisaoFormatado;

export const getDataDaDivulgacaoDePremiadosFormatado = contexts => contexts.dataDivulgacaoPremiados;

export const isPeriodoInscricao = contexts => contexts.periodoInscricao;
export const isPeriodoInscricaoAdministrador = contexts => contexts.periodoInscricaoAdministrador;
export const isInscricoesAbertas = contexts => isPeriodoInscricao(contexts) || (isAdministradorOuCentral() && isPeriodoInscricaoAdministrador(contexts));

export const isPeriodoPagamento = contexts => contexts.periodoPagamento;
export const isPeriodoPagamentoAdministrador = contexts => contexts.periodoPagamentoAdministrador;
export const isPeriodoConfirmacao = contexts => contexts.periodoConfirmacao;
export const isPeriodoTransito = contexts => contexts.periodoTransito;
export const isPeriodoDivulgacaoLocalProva = contexts => contexts.periodoDivulgacaoLocalProva;
export const isDiaDaProva = contexts => contexts.diaDaProva;
export const isPeriodoDivulgacaoNotas = contexts => contexts.periodoDivulgacaoNotas;
export const isPeriodoRevisao = contexts => contexts.periodoRevisao;
export const isPeriodoDivulgacaoPremiados = contexts => contexts.periodoDivulgacaoPremiados;

export const isAposDiaDaProva = contexts => contexts.aposDiaDaProva;
export const isAposFimInscricaoFimPagamento = contexts => contexts.aposFimInscricaoEFimPagamento;